import dayjs from 'dayjs';
// `dayjs(dto.date)` only, not `dayjs(dto.date, 'DD-MM-YYYY')` — that second argument does nothing
// without the `customParseFormat` plugin (not registered anywhere in this repo), so datahub's own
// mapper silently ignores it. Not carrying the dead argument forward.
export function mapNewsFromDto({ id, title, teaser, content, date }) {
    return {
        id,
        title,
        subTitle: teaser,
        content,
        date: dayjs(date).toDate(),
    };
}
